/**
 * DocumentationIcon/index.js
 * desc: content documentation icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const DocumentationIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="documentation icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.documentation.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20"><path fillRule="evenodd" d="M2 0h12c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0zm5 2H2v8l2.5-1.5L7 10V2z"/></svg>
    </IconButton>
);


export default DocumentationIcon;
